export default __webpack_public_path__ + "static/media/icon-mail.d10b1246.svg";